import React from "react";

function Briefcase01({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox="0 0 24 24"
      {...restProps}
    >
      <path
        d="M10.66 2.202a4.34 4.34 0 0 0-1.4.388c-.666.336-1.334 1.004-1.67 1.67-.176.351-.352.968-.374 1.316-.011.178-.029.38-.039.449l-.019.125-1.709.022c-1.822.024-2.092.049-2.552.235a2.807 2.807 0 0 0-1.49 1.49c-.232.573-.226.414-.226 6.103s-.006 5.53.226 6.103a2.807 2.807 0 0 0 1.49 1.49c.59.238.118.226 9.063.227 8.662 0 8.457.004 9.03-.184.295-.097.759-.392 1.006-.64.248-.247.543-.711.64-1.006.184-.56.184-.563.184-5.99 0-5.427 0-5.43-.184-5.99-.219-.664-.854-1.329-1.533-1.603-.46-.186-.73-.211-2.552-.235l-1.709-.022-.019-.125a7.74 7.74 0 0 1-.039-.447c-.033-.523-.293-1.25-.617-1.728a5.001 5.001 0 0 0-1.017-1.017c-.526-.357-1.187-.579-1.887-.634a25.687 25.687 0 0 0-2.603.003m2.739 1.677c.521.075 1.099.459 1.407.935.213.329.305.602.337 1.001l.028.345H8.829l.028-.345a2.086 2.086 0 0 1 .7-1.425c.261-.234.723-.467 1.008-.509.309-.045 2.527-.046 2.834-.002m7.111 4.076a1.1 1.1 0 0 1 .546.563l.084.182v10.6l-.112.228c-.125.254-.28.404-.548.528l-.18.084h-8.28c-8.026 0-8.286-.002-8.476-.076a1.064 1.064 0 0 1-.589-.554l-.095-.21V8.7l.092-.2c.158-.342.414-.545.782-.619.091-.018 3.856-.03 8.366-.027l8.2.006.21.095"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default Briefcase01;
